import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ToggleButton, ToggleButtonGroup, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

const DailyViewNavigation = ({ date }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const handleViewChange = (_event, newView) => {
    if (newView !== null) {
      if (newView === 'overview') {
        navigate(`/chart/daily/overview/${date}`);
      } else if (newView === 'components') {
        navigate(`/chart/daily/plannings/${date}`);
      } else {
        navigate(`/chart/daily/${newView}/${date}`);
      }
    }
  };

  const currentView = location.pathname.split('/')[3] || 'overview';

  return (
    <Box sx={{ pt: 2 }}>
      <ToggleButtonGroup
        value={currentView}
        exclusive
        onChange={handleViewChange}
        orientation="vertical"
        sx={{
          width: '100%',
          '& .MuiToggleButton-root': {
            justifyContent: 'flex-start',
            textTransform: 'none',
            fontSize: '0.875rem',
            width: '100%',
            border: 'none',
            borderRadius: 0,
            '&.Mui-selected': {
              backgroundColor: 'action.selected',
              borderColor: 'primary.main',
            }
          }
        }}
      >
        <ToggleButton value="overview">{t('daily.nav.overview')}</ToggleButton>
        <ToggleButton value="components">{t('daily.nav.operations')}</ToggleButton>
        <ToggleButton value="hours">{t('daily.nav.worktime')}</ToggleButton>
        <ToggleButton value="workcell-schedule">{t('daily.nav.workcellActivity')}</ToggleButton>
        <ToggleButton value="operator-schedule">{t('daily.nav.operatorSchedule')}</ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

export default DailyViewNavigation;
